

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import MenuButtonAdd from 'components/presenter/item/folder/MenuButtonAdd.vue'
import ContentSubfolders from 'components/presenter/item/folder/ContentSubfolders.vue'
import ContentSubitems from 'components/presenter/item/folder/ContentSubitems.vue'
import api from 'src/assets/api/gql'
import ItemShareFoldersList from 'src/graphql/item_share_folder/ItemShareFoldersList.gql'
import ItemChildrenList from 'src/graphql/item/ItemChildrenList.gql'
import { Item, ItemType, ItemShareFolder } from 'src/graphql/types'

@Component({
  components: {
    MenuButtonAdd,
    ContentSubfolders,
    ContentSubitems
  }
})
export default class ItemFolderContent extends Vue {
  loading = false
  loadingShareFolders = true
  loadCursor: string | null = null
  folders: Array<Item | ItemShareFolder> = []
  courses: Item[] = []
  topics: Item[] = []

  @Prop()
  readonly item!: Item

  get subitems () {
    return [...this.courses, ...this.topics]
  }

  async refresh (done: () => void) {
    this.folders = []
    this.courses = []
    this.topics = []
    this.loadingShareFolders = true
    this.loadCursor = null
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    this.loading = true
    if (this.item.id) {
      await this.loadChildren(this.item.id)
    } else {
      if (this.loadingShareFolders) {
        await this.loadShareFolders()
        this.loadingShareFolders = !!this.loadCursor
      }
      if (!this.loadingShareFolders) {
        await this.loadChildren(0)
      }
    }
    done(!this.loadCursor)
    this.loading = false
  }

  async loadShareFolders () {
    const { data: { itemShareFolders } } = await api.query({
      query: ItemShareFoldersList,
      variables: {
        after: this.loadCursor
      }
    })
    if (itemShareFolders) {
      for (const item of itemShareFolders.nodes as ItemShareFolder[]) {
        if (item) {
          this.folders.push(item as ItemShareFolder)
        }
      }
      this.loadCursor = itemShareFolders.pageInfo.hasNextPage ? itemShareFolders.pageInfo.endCursor : null
    }
  }

  async loadChildren (id: number) {
    const { data: { itemChildren } } = await api.query({
      query: ItemChildrenList,
      variables: {
        id,
        after: this.loadCursor
      }
    })
    if (itemChildren) {
      for (const item of itemChildren.nodes as Item[]) {
        if (item) {
          switch (item.type) {
            case ItemType.Folder:
              this.folders.push(item)
              break
            case ItemType.Course:
              this.courses.push(item)
              break
            case ItemType.Topic:
              this.topics.push(item)
              break
          }
        }
      }
      this.loadCursor = itemChildren.pageInfo.hasNextPage ? itemChildren.pageInfo.endCursor : null
    }
  }
}
